<template>
    <div class="ro-page">
        <!-- Toolbar -->
        <div class="ro-toolbar">
            <div class="ro-toolbar__left">
                <div class="ro-toolbar__brand">
                    <div class="ro-toolbar__icon-box">
                        <i class="el-icon-s-order"></i>
                    </div>
                    <div>
                        <h3 class="ro-toolbar__title">Order tuyển nhân sự</h3>
                        <div class="ro-toolbar__subtitle">Quản lý và theo dõi các yêu cầu tuyển dụng trong hệ thống</div>
                    </div>
                </div>

            </div>
            <div class="ro-toolbar__right">
                <el-button
                    v-if="canCreateOrder"
                    size="small"
                    type="primary"
                    icon="el-icon-plus"
                    class="ro-btn-create"
                    @click="openCreate"
                >
                    Tạo order mới
                </el-button>
            </div>
        </div>

        <!-- KPI Metric Cards -->
        <div class="ro-stats-grid">
            <div class="ro-stat-card ro-stat-card--indigo">
                <div class="ro-stat-card__icon">
                    <i class="el-icon-document-copy"></i>
                </div>
                <div class="ro-stat-card__content">
                    <div class="ro-stat-card__label">Tổng yêu cầu</div>
                    <div class="ro-stat-card__value">{{ statTotalOrders }}</div>
                </div>
            </div>
            <div class="ro-stat-card ro-stat-card--amber">
                <div class="ro-stat-card__icon">
                    <i class="el-icon-time"></i>
                </div>
                <div class="ro-stat-card__content">
                    <div class="ro-stat-card__label">Chờ duyệt</div>
                    <div class="ro-stat-card__value">{{ statPendingApprove }}</div>
                </div>
            </div>
            <div class="ro-stat-card ro-stat-card--emerald">
                <div class="ro-stat-card__icon">
                    <i class="el-icon-circle-check"></i>
                </div>
                <div class="ro-stat-card__content">
                    <div class="ro-stat-card__label">Đã duyệt / Đang tuyển</div>
                    <div class="ro-stat-card__value">{{ statApproved }}</div>
                </div>
            </div>
            <div class="ro-stat-card ro-stat-card--blue">
                <div class="ro-stat-card__icon">
                    <i class="el-icon-user"></i>
                </div>
                <div class="ro-stat-card__content">
                    <div class="ro-stat-card__label">Ứng viên đã nộp</div>
                    <div class="ro-stat-card__value">{{ statTotalCvs }}</div>
                </div>
            </div>
        </div>

        <!-- Tabs theo vai trò -->
        <el-tabs v-model="activeTab" class="ro-tabs" @tab-click="onTabChange">
            <el-tab-pane label="Tất cả đơn" name="all">
                <template slot="label">
                    <span>Tất cả đơn</span>
                    <span v-if="allCount" class="ro-tab-count ro-tab-count--info">{{ allCount }}</span>
                </template>
            </el-tab-pane>
            <el-tab-pane v-if="isApprover" name="approve">
                <template slot="label">
                    <span>Chờ tôi duyệt</span>
                    <span v-if="approveCount" class="ro-tab-count ro-tab-count--warn">{{ approveCount }}</span>
                </template>
            </el-tab-pane>
            <el-tab-pane v-if="canSeeCoordinateTab" name="coordinate">
                <template slot="label">
                    <span><i class="el-icon-connection mr-1"></i> Điều phối job</span>
                    <span v-if="coordinatePendingCount" class="ro-tab-count ro-tab-count--warn">{{ coordinatePendingCount }}</span>
                </template>
            </el-tab-pane>
        </el-tabs>

        <!-- Banner khi ở tab Điều phối job -->
        <div v-if="activeTab === 'coordinate'" class="ro-coordinate-banner">
            <div class="ro-coordinate-banner__icon">
                <i class="el-icon-connection"></i>
            </div>
            <div class="ro-coordinate-banner__body">
                <div class="ro-coordinate-banner__title">Màn hình điều phối tuyển dụng (KHSX / Tuyển hộ)</div>
                <div class="ro-coordinate-banner__desc">
                    Danh sách các yêu cầu tuyển dụng cần điều phối. Hãy bấm nút <b>Gán trưởng nhóm</b> tại cột Phụ trách / Điều phối để chỉ định Trưởng nhóm phụ trách job tuyển hộ.
                </div>
            </div>
            <div class="ro-coordinate-banner__action">
                <span class="ro-coordinate-banner__pill">
                    <i class="el-icon-time"></i> {{ coordinatePendingCount }} job chưa gán trưởng nhóm
                </span>
            </div>
        </div>

        <!-- Filter -->
        <div class="ro-card ro-filter-card">
            <order-filter-bar
                v-model="filters"
                :departments="departments"
                :show-department-filter="isHrDepartment"
                @change="onFilterChange"
            />
        </div>

        <!-- Table -->
        <div class="ro-card">
            <order-table
                :orders="visibleOrders"
                :loading="roLoading"
                :current-user-id="currentUserId"
                :current-user="currentUser"
                :is-coordinator="isCoordinator || hasAnyCoordinatedJob"
                :can-assign-cv-approver="canAssignCvApprover"
                :can-assign-person-in-charge="canAssignPersonInCharge"
                :show-remaining-days="isHrDepartment"
                :show-approval-level="isHrOrTcDepartment"
                @view="openDetail"
                @view-cvs="handleViewCvs"
                @edit="openEdit"
                @assign="openAssign"
                @assign-cv-approver="openAssignCvApprover"
                @delete="handleDelete"
                @teamlead-approve="handleTeamleadApprove"
                @hiring-start-date-saved="handleHiringStartDateSaved"
            />

            <!-- Pagination -->
            <div v-if="roPagination && roPagination.total > 0" class="ro-pagination">
                <el-pagination
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="roPagination.total"
                    :page-size="pagination.limit"
                    :page-sizes="[10, 15, 20, 50]"
                    :current-page="pagination.page"
                    @current-change="handlePageChange"
                    @size-change="handleSizeChange"
                />
            </div>
        </div>

        <!-- Dialog Thêm mới / Chỉnh sửa order -->
        <order-form-dialog
            :visible.sync="formDialogVisible"
            :order-data="selectedEditOrder"
            :submitting="submitting"
            :allow-teacher-type="allowTeacherOrderType"
            :can-assign-cv-approver="canAssignCvApprover"
            :can-assign-person-in-charge="canAssignPersonInCharge"
            :current-user="currentUser"
            @submit="handleFormSubmit"
            @approve-order="handleApproveOrder"
            @teamlead-approve="handleApproveOrder"
        />

        <!-- Dialog Chi tiết order -->
        <order-detail-dialog
            :visible.sync="detailDialogVisible"
            :order="selectedOrder"
            :current-user-id="currentUserId"
            :current-user="currentUser"
            :is-coordinator="isCoordinator || hasAnyCoordinatedJob"
            :can-assign-cv-approver="canAssignCvApprover"
            :can-assign-person-in-charge="canAssignPersonInCharge"
            :show-remaining-days="isHrDepartment"
            :show-approval-level="isHrOrTcDepartment"
            :submitting="submitting"
            @edit="openEdit"
            @assign="openAssign"
            @assign-cv-approver="openAssignCvApprover"
            @approve-order="handleApproveOrder"
            @teamlead-approve="handleApproveOrder"
        />

        <!-- Dialog Gán người phụ trách -->
        <assign-person-in-charge-dialog
            :visible.sync="assignDialogVisible"
            :order="selectedAssignOrder"
            :submitting="submitting"
            :hr-team-leads="roHrTeamLeads"
            :is-hr-department="isHrDepartment"
            :is-coordinator="isCoordinator || hasAnyCoordinatedJob"
            :current-user-id="currentUserId"
            :can-assign-person-in-charge="canAssignPersonInCharge"
            @submit="handleAssignSubmit"
        />

        <!-- Dialog Gán người duyệt CV -->
        <assign-cv-approver-dialog
            :visible.sync="assignCvApproverDialogVisible"
            :order="selectedAssignCvApproverOrder"
            :submitting="submitting"
            @submit="handleAssignCvApproverSubmit"
        />

        <!-- Dialog Chị Ngà duyệt bắt buộc chọn Người điều phối khi chưa có trưởng nhóm phụ trách -->
        <assign-coordinator-approve-dialog
            :visible.sync="approveCoordinatorDialogVisible"
            :order="selectedApproveCoordinatorOrder"
            :submitting="submitting"
            :hr-team-leads="roHrTeamLeads"
            @confirm="handleApproveWithCoordinator"
        />
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { USER_PROFILE, GET_DEPARTMENT } from "@/core/services/store/profile.module";
import {
    RO_GET_ORDERS,
    RO_CREATE_ORDER,
    RO_UPDATE_ORDER,
    RO_DELETE_ORDER,
    RO_GET_HR_TEAMLEADS,
    RO_ASSIGN_CV_APPROVER,
    RO_GET_WORK_FORMS,
} from "@/core/services/store/recruitment-orders/recruitmentOrders.module";
import {
    TEAM_LEAD_ACCOUNT_TYPE_ID,
    HR_DEPARTMENT_IDS,
    DEPARTMENT_HR,
    DEPARTMENT_TCGV,
    DEPARTMENT_TUYEN_HO,
    isCoordinatorUser,
    isHrLeadUser,
    isTeacherApproverUser,
    pendingApprovalFor,
    resolveDepartmentIds,
    canCreateTeacherOrder,
    canUserAssignCvApprover,
    ORDER_STATUS,
    isOrderApproved,
    isOrderRejected,
    TYPE_TUYEN_HO,
    orderTypeOf,
    canUserCreateOrder,
    resolveAccountTypeIds,
    canUserApproveHr,
    canUserApproveTeamlead,
    canUserApproveOrRejectOrder,
    canUserAssignPersonInCharge,
    BOD,
    TEAMLEADER,
    TRUONG_BO_PHAN,
    TRUONG_NHOM,
} from "@/core/config/recruitmentOrders/recruitmentOrdersOption";
import OrderFilterBar from "./components/OrderFilterBar.vue";
import OrderTable from "./components/OrderTable.vue";
import OrderFormDialog from "./components/OrderFormDialog.vue";
import OrderDetailDialog from "./components/OrderDetailDialog.vue";
import AssignPersonInChargeDialog from "./components/AssignPersonInChargeDialog.vue";
import AssignCvApproverDialog from "./components/AssignCvApproverDialog.vue";
import AssignCoordinatorApproveDialog from "./components/AssignCoordinatorApproveDialog.vue";

export default {
    name: "RecruitmentOrders",
    components: {
        OrderFilterBar,
        OrderTable,
        OrderFormDialog,
        OrderDetailDialog,
        AssignPersonInChargeDialog,
        AssignCvApproverDialog,
        AssignCoordinatorApproveDialog,
    },
    data() {
        return {
            activeTab: "all",
            filters: { status: "", type: "", department_id: "", keyword: "" },
            departments: [],
            profileDepartmentIds: [],
            userProfileData: null,

            pagination: {
                page: 1,
                limit: 15,
            },

            formDialogVisible: false,
            detailDialogVisible: false,
            assignDialogVisible: false,
            assignCvApproverDialogVisible: false,
            approveCoordinatorDialogVisible: false,
            selectedOrder: null,
            selectedEditOrder: null,
            selectedAssignOrder: null,
            selectedAssignCvApproverOrder: null,
            selectedApproveCoordinatorOrder: null,
            submitting: false,
        };
    },
    computed: {
        ...mapGetters(["currentUser", "roOrders", "roPagination", "roHrTeamLeads", "roLoading"]),
        currentUserId() {
            return this.currentUser && this.currentUser.id;
        },
        myAccountTypeId() {
            const u = this.currentUser || {};
            return (u.profile && u.profile.account_type_id) || (u.account_type && u.account_type.id) || u.account_type_id || null;
        },
        userAccountTypeIds() {
            return resolveAccountTypeIds(this.currentUser, this.userProfileData);
        },
        myDepartmentIds() {
            const ids = new Set((this.profileDepartmentIds || []).map(Number));
            resolveDepartmentIds(this.currentUser).forEach((id) => ids.add(Number(id)));
            if (this.userProfileData) {
                resolveDepartmentIds(this.userProfileData).forEach((id) => ids.add(Number(id)));
            }
            return [...ids].filter(Boolean);
        },
        /** Thuộc phòng Nhân sự (department_id = 3) -> được hiển thị và sử dụng bộ lọc phòng ban */
        isHrDepartment() {
            return this.myDepartmentIds.includes(DEPARTMENT_HR);
        },
        /** Thuộc phòng Nhân sự (department_id = 3) hoặc phòng Tuyển hộ (department_id = 44 / 52) */
        isHrOrTcDepartment() {
            return this.myDepartmentIds.includes(DEPARTMENT_HR) || this.myDepartmentIds.includes(DEPARTMENT_TUYEN_HO) || this.myDepartmentIds.includes(DEPARTMENT_TCGV);
        },
        /** Thuộc phòng có department_id = 44 -> được tạo order Tuyển hộ (Giáo viên) */
        allowTeacherOrderType() {
            return canCreateTeacherOrder(this.currentUser, this.myDepartmentIds);
        },
        canCreateOrder() {
            return canUserCreateOrder(this.currentUser, this.userProfileData, this.profileDepartmentIds);
        },
        /** Thuộc phòng Nhân sự (department_id = 3) & account_type_id = 16 -> HR duyệt / từ chối */
        canApproveHr() {
            return canUserApproveHr(this.currentUser, this.userProfileData, this.profileDepartmentIds);
        },
        /** Thuộc phòng TCGV (department_id = 52) & account_type_id = 16 -> Teamlead duyệt / từ chối */
        canApproveTeamlead() {
            return canUserApproveTeamlead(this.currentUser, this.userProfileData, this.profileDepartmentIds);
        },
        /** Có quyền duyệt / từ chối order */
        canApproveOrRejectOrder() {
            return canUserApproveOrRejectOrder(this.currentUser, this.userProfileData, this.profileDepartmentIds);
        },
        /** Thuộc phòng Nhân sự (department_id = 3) -> được gán người duyệt CV */
        canAssignCvApprover() {
            return canUserAssignCvApprover(this.currentUser, this.userProfileData, this.profileDepartmentIds);
        },
        /** Chỉ account_type_id = 16 của department_id = 3 mới được gán HR phụ trách */
        canAssignPersonInCharge() {
            return canUserAssignPersonInCharge(this.currentUser, this.userProfileData, this.profileDepartmentIds);
        },
        isBod() {
            return this.userAccountTypeIds.includes(BOD);
        },
        isTruongPhong() {
            return this.userAccountTypeIds.includes(TEAMLEADER);
        },
        isTruongBoPhan() {
            return this.userAccountTypeIds.includes(TRUONG_BO_PHAN);
        },
        isTruongNhom() {
            return this.userAccountTypeIds.includes(TRUONG_NHOM);
        },
        isTeamLead() {
            return this.isTruongPhong || Number(this.myAccountTypeId) === TEAM_LEAD_ACCOUNT_TYPE_ID;
        },
        isHrTeamlead() {
            return this.isTeamLead && this.myDepartmentIds.some((id) => HR_DEPARTMENT_IDS.includes(id));
        },
        isCoordinator() {
            return isCoordinatorUser(this.currentUser);
        },
        hasAnyCoordinatedJob() {
            const myId = String(this.currentUserId || "");
            if (!myId) return false;
            return this.roOrders.some((o) => o.coordinator_id && String(o.coordinator_id) === myId);
        },
        canSeeCoordinateTab() {
            return this.isCoordinator || this.hasAnyCoordinatedJob || this.isHrLead || this.isBod;
        },
        isHrLead() {
            return isHrLeadUser(this.currentUser);
        },
        isTeacherApprover() {
            return isTeacherApproverUser(this.currentUser);
        },
        isApprover() {
            return this.isHrLead || this.isTeacherApprover;
        },
        primaryRoleKey() {
            if (this.isHrLead) return "hr_lead";
            if (this.isTeacherApprover) return "teacher_approver";
            if (this.isCoordinator) return "coordinator";
            if (this.isHrTeamlead) return "hr_teamlead";
            if (this.isBod) return "bod";
            if (this.isTruongPhong) return "truong_phong";
            if (this.isTruongBoPhan) return "truong_bo_phan";
            if (this.isTruongNhom) return "truong_nhom";
            if (this.isTeamLead) return "team_lead";
            return "viewer";
        },
        approveOrders() {
            return this.roOrders.filter((o) => pendingApprovalFor(o, this.currentUser) || Number(o.hr_approve) === 0);
        },
        coordinateOrders() {
            const myId = String(this.currentUserId || "");
            return this.roOrders.filter((o) => {
                const isAssignedToMe = o.coordinator_id && String(o.coordinator_id) === myId;
                if (isAssignedToMe) return true;
                if (this.isCoordinator || this.isHrLead || this.isBod) {
                    const isTeacherJob = Number(o.type) === TYPE_TUYEN_HO || orderTypeOf(o) === TYPE_TUYEN_HO;
                    return isTeacherJob && (o.coordinator_id || !o.person_in_charge_id);
                }
                return false;
            });
        },
        allCount() {
            return (this.roPagination && this.roPagination.total) || this.roOrders.length;
        },
        approveCount() {
            return this.approveOrders.length;
        },
        coordinateCount() {
            return this.coordinateOrders.length;
        },
        coordinatePendingCount() {
            return this.coordinateOrders.filter(
                (o) => !o.person_in_charge_id && !(o.person_in_charge && o.person_in_charge.id)
            ).length;
        },
        visibleOrders() {
            if (this.activeTab === "approve") return this.approveOrders;
            if (this.activeTab === "coordinate") return this.coordinateOrders;
            return this.roOrders;
        },
        statTotalOrders() {
            return (this.roPagination && this.roPagination.total) || this.roOrders.length;
        },
        statPendingApprove() {
            return this.roOrders.filter(
                (o) => Number(o.hr_approve) === 0 || Number(o.teamlead_approve) === 0
            ).length;
        },
        statApproved() {
            return this.roOrders.filter((o) => isOrderApproved(o)).length;
        },
        statTotalCvs() {
            return this.roOrders.reduce((sum, o) => sum + ((o.cvs && o.cvs.length) || 0), 0);
        },
    },
    mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [{ title: "Order tuyển nhân sự", icon: "fas fa-user-plus" }]);
        this.loadProfileDepartment();
        this.loadDepartments();
        this.loadOrders();
        // Endpoint hr-teamleads chưa có ở BE -> im lặng, không chặn trang
        this.$store.dispatch(RO_GET_HR_TEAMLEADS).catch(() => {});
        this.$store.dispatch(RO_GET_WORK_FORMS).catch(() => {});
        console.log(this.currentUser, 'aaa');
        
    },
    methods: {
        loadProfileDepartment() {
            this.$store
                .dispatch(USER_PROFILE)
                .then((res) => {
                    const data = res && res.data ? res.data : res;
                    this.userProfileData = data;
                    this.profileDepartmentIds = resolveDepartmentIds(data);
                })
                .catch(() => {});
        },
        loadDepartments() {
            this.$store
                .dispatch(GET_DEPARTMENT)
                .then((res) => {
                    this.departments = Array.isArray(res) ? res : res && res.data ? res.data : [];
                })
                .catch(() => {});
        },
        loadOrders() {
            const params = {
                currentUserId: this.currentUserId,
                currentUserName: this.currentUser && this.currentUser.name,
                keyword: this.filters.keyword || undefined,
                type: this.filters.type || undefined,
                status: this.filters.status || undefined,
                department_id: this.isHrDepartment ? (this.filters.department_id || undefined) : undefined,
                page: this.pagination.page,
                limit: this.pagination.limit,
            };
            this.$store
                .dispatch(RO_GET_ORDERS, params)
                .catch(() => this.$message.error("Không tải được danh sách order tuyển dụng"));
        },
        onFilterChange() {
            this.pagination.page = 1;
            this.loadOrders();
        },
        onTabChange() {
            // tab filter
        },
        handlePageChange(page) {
            this.pagination.page = page;
            this.loadOrders();
        },
        handleSizeChange(limit) {
            this.pagination.limit = limit;
            this.pagination.page = 1;
            this.loadOrders();
        },
        openCreate() {
            if (!this.canCreateOrder) {
                this.$message.warning(
                    "Chỉ nhân sự thuộc BOD (15), Trưởng phòng (16), Trưởng bộ phận (32), Trưởng nhóm (34) hoặc Phòng Tuyển hộ (department_id = 44) mới được tạo order"
                );
                return;
            }
            this.selectedEditOrder = null;
            this.formDialogVisible = true;
        },
        openEdit(order) {
            this.selectedEditOrder = { ...order };
            this.formDialogVisible = true;
        },
        openDetail(order) {
            this.selectedOrder = order;
            this.detailDialogVisible = true;
        },
        canUserAssignForOrder(order) {
            if (!order) return false;
            if (this.canAssignPersonInCharge) return true;
            const isTeacher = Number(order.type) === TYPE_TUYEN_HO || orderTypeOf(order) === TYPE_TUYEN_HO;
            if (isTeacher) {
                const myId = String(this.currentUserId || "");
                if (this.isCoordinator) return true;
                if (order.coordinator_id && String(order.coordinator_id) === myId) return true;
            }
            return false;
        },
        openAssign(order) {
            if (!this.canUserAssignForOrder(order)) {
                this.$message.warning("Bạn không có quyền gán người phụ trách cho yêu cầu tuyển dụng này");
                return;
            }
            if (!isOrderApproved(order)) {
                this.$message.warning("Chỉ yêu cầu tuyển dụng ở trạng thái Đã duyệt mới được gán người phụ trách");
                return;
            }
            this.selectedAssignOrder = { ...order };
            this.assignDialogVisible = true;
        },
        handleAssignSubmit(payload) {
            const order = this.selectedAssignOrder || payload;
            if (!this.canUserAssignForOrder(order)) {
                this.$message.warning("Bạn không có quyền gán người phụ trách");
                return;
            }
            this.submitting = true;
            this.$store
                .dispatch(RO_UPDATE_ORDER, {
                    id: payload.id,
                    person_in_charge_id: payload.person_in_charge_id,
                })
                .then(() => {
                    this.$message.success("Gán Trưởng nhóm phụ trách thành công");
                    this.assignDialogVisible = false;
                    if (this.selectedOrder && String(this.selectedOrder.id) === String(payload.id)) {
                        this.selectedOrder = {
                            ...this.selectedOrder,
                            person_in_charge_id: payload.person_in_charge_id,
                            person_in_charge: payload.person_in_charge || this.selectedOrder.person_in_charge,
                        };
                    }
                    this.loadOrders();
                })
                .catch((err) => {
                    const msg =
                        (err && err.response && err.response.data && err.response.data.message) ||
                        "Gán người phụ trách thất bại";
                    this.$message.error(msg);
                })
                .finally(() => {
                    this.submitting = false;
                });
        },
        openAssignCvApprover(order) {
            if (isOrderRejected(order)) {
                this.$message.warning("Yêu cầu tuyển dụng đã bị từ chối, không thể gán người duyệt CV");
                return;
            }
            if (orderTypeOf(order) !== TYPE_TUYEN_HO) {
                this.$message.warning("Chỉ yêu cầu tuyển hộ mới được gán người duyệt CV");
                return;
            }
            if (!this.canAssignCvApprover) {
                this.$message.warning("Chỉ nhân sự thuộc Phòng Nhân sự mới được gán người duyệt CV");
                return;
            }
            this.selectedAssignCvApproverOrder = { ...order };
            this.assignCvApproverDialogVisible = true;
        },
        handleAssignCvApproverSubmit(payload) {
            this.submitting = true;
            this.$store
                .dispatch(RO_ASSIGN_CV_APPROVER, {
                    id: payload.id,
                    cv_approver_id: payload.cv_approver_id,
                    cv_approver: payload.cv_approver,
                })
                .then(() => {
                    this.$message.success("Gán người duyệt CV thành công");
                    this.assignCvApproverDialogVisible = false;
                    if (this.selectedOrder && String(this.selectedOrder.id) === String(payload.id)) {
                        this.selectedOrder = {
                            ...this.selectedOrder,
                            cv_approver_id: payload.cv_approver_id,
                            cv_approver: payload.cv_approver || this.selectedOrder.cv_approver,
                            cv_approver_name: (payload.cv_approver && payload.cv_approver.name) || this.selectedOrder.cv_approver_name,
                        };
                    }
                    this.loadOrders();
                })
                .catch((err) => {
                    const msg =
                        (err && err.response && err.response.data && err.response.data.message) ||
                        "Gán người duyệt CV thất bại";
                    this.$message.error(msg);
                })
                .finally(() => {
                    this.submitting = false;
                });
        },
        handleHiringStartDateSaved(data) {
            if (this.selectedOrder && data && data.order && String(this.selectedOrder.id) === String(data.order.id)) {
                this.selectedOrder = {
                    ...this.selectedOrder,
                    hiring_start_date: data.hiring_start_date,
                };
            }
            this.loadOrders();
        },
        extractApiErrorMessage(err, defaultMsg = "Đã có lỗi xảy ra") {
            if (!err) return defaultMsg;
            const payload =
                (err.response && err.response.data) ||
                (err.data !== undefined && typeof err.data === "object" && (err.data.message_validate_form || err.data.error || err.data.message || err.data.errors) ? err.data : null) ||
                err;

            const fieldLabels = {
                recruitment_job_category_id: "Phân loại",
                "recruitment job category id": "Phân loại",
                job_catalog_id: "Phân loại",
                title: "Tiêu đề yêu cầu tuyển dụng",
                type: "Hình thức tuyển dụng",
                recruitment_job_detail_id: "Chi tiết",
                "recruitment job detail id": "Chi tiết",
                recruitment_job_detail_name: "Chi tiết",
                "recruitment job detail name": "Chi tiết",
                job_detail_id: "Chi tiết",
                job_detail: "Chi tiết",
                branch_id: "Địa điểm làm việc",
                "branch id": "Địa điểm làm việc",
                area: "Khu vực",
                area_id: "Khu vực",
                "area id": "Khu vực",
                work_type: "Hình thức làm việc",
                "work type": "Hình thức làm việc",
                working_form: "Hình thức làm việc",
                start_date: "Thời gian bắt đầu",
                "start date": "Thời gian bắt đầu",
                end_date: "Thời gian kết thúc",
                "end date": "Thời gian kết thúc",
                quantity: "Số lượng cần tuyển",
                amount: "Số lượng cần tuyển",
                person_in_charge_id: "Người phụ trách",
                "person in charge id": "Người phụ trách",
                cv_approver_id: "Người duyệt CV",
                "cv approver id": "Người duyệt CV",
                code_order: "Mã đơn",
                "code order": "Mã đơn",
                description: "Mô tả",
            };

            const translateMessage = (msg, fieldKey = "") => {
                if (!msg || typeof msg !== "string") return msg;
                let clean = msg;
                const fieldName = fieldLabels[fieldKey] || (fieldKey ? fieldKey : "");

                if (/The (.+) field is required/i.test(clean)) {
                    const match = clean.match(/The (.+) field is required/i);
                    const rawF = match && match[1] ? match[1].trim() : "";
                    const f = fieldLabels[rawF] || fieldLabels[rawF.replace(/ /g, "_")] || fieldName || rawF;
                    return `Vui lòng nhập/chọn ${f}`;
                }
                if (/Trường (.+) là bắt buộc/i.test(clean)) {
                    const match = clean.match(/Trường (.+) là bắt buộc/i);
                    const rawF = match && match[1] ? match[1].trim() : "";
                    const f = fieldLabels[rawF] || fieldLabels[rawF.replace(/ /g, "_")] || fieldName || rawF;
                    return `Vui lòng nhập/chọn ${f}`;
                }

                Object.keys(fieldLabels).forEach((k) => {
                    const reg = new RegExp(`\\b${k}\\b`, "gi");
                    clean = clean.replace(reg, fieldLabels[k]);
                });
                return clean;
            };

            if (payload && typeof payload === "object") {
                // 1. Kiểm tra message_validate_form hoặc errors
                const mv = (payload.data && (payload.data.message_validate_form || payload.data.errors)) || payload.message_validate_form || payload.errors;
                if (mv && typeof mv === "object") {
                    const keys = Object.keys(mv);
                    if (keys.length > 0) {
                        const firstKey = keys[0];
                        const firstVal = mv[firstKey];
                        if (Array.isArray(firstVal) && firstVal.length > 0 && firstVal[0]) {
                            return translateMessage(firstVal[0], firstKey);
                        }
                        if (typeof firstVal === "string" && firstVal) {
                            return translateMessage(firstVal, firstKey);
                        }
                    }
                }

                // 2. Kiểm tra message
                if (payload.message && typeof payload.message === "string") {
                    return translateMessage(payload.message);
                }

                // 3. Kiểm tra error nếu là chuỗi
                if (typeof payload.error === "string" && payload.error) {
                    return translateMessage(payload.error);
                }
            }

            if (typeof err === "string") return translateMessage(err);
            if (err.message && typeof err.message === "string") return translateMessage(err.message);
            return defaultMsg;
        },
        handleFormSubmit(payload) {
            this.submitting = true;
            const isEdit = !!payload.id;
            const action = isEdit ? RO_UPDATE_ORDER : RO_CREATE_ORDER;
            const successMsg = isEdit ? "Cập nhật yêu cầu tuyển dụng thành công" : "Tạo yêu cầu tuyển dụng thành công";

            const submitPayload = {
                ...payload,
                created_by: this.currentUserId,
                created_by_name: this.currentUser && this.currentUser.name,
            };

            // Với order Tuyển hộ (Giáo viên), không tự gán người phụ trách hay người duyệt CV tại lúc tạo mới.
            // Với order phòng ban, người tạo sẽ là người phụ trách, không có người duyệt CV.
            const isTcgv = this.myDepartmentIds.includes(DEPARTMENT_TUYEN_HO) || this.myDepartmentIds.includes(DEPARTMENT_TCGV) || (this.currentUser && (Number(this.currentUser.department_id) === DEPARTMENT_TUYEN_HO || Number(this.currentUser.department_id) === DEPARTMENT_TCGV));
            const isTeacher = Number(submitPayload.type) === TYPE_TUYEN_HO;
            if (!isEdit) {
                if (isTeacher) {
                    // KHSX tạo thì có thể chọn trưởng nhóm phụ trách luôn (giữ lại person_in_charge_id nếu chọn)
                    submitPayload.person_in_charge_id = submitPayload.person_in_charge_id || null;
                    submitPayload.cv_approver_id = null;
                } else {
                    submitPayload.cv_approver_id = null;
                    if (!isTcgv && this.currentUserId && !submitPayload.person_in_charge_id) {
                        submitPayload.person_in_charge_id = this.currentUserId;
                    }
                }
            }

            this.$store
                .dispatch(action, submitPayload)
                .then(() => {
                    this.$message.success(successMsg);
                    this.formDialogVisible = false;
                    this.loadOrders();
                })
                .catch((err) => {
                    const fallbackMsg = isEdit ? "Cập nhật order thất bại" : "Tạo order thất bại";
                    const msg = this.extractApiErrorMessage(err, fallbackMsg);
                    this.$message.error(msg);
                })
                .finally(() => {
                    this.submitting = false;
                });
        },
        handleViewCvs(order) {
            if (!order || !order.id) return;
            const rJobId = (order.recruitment_job_id !== undefined && order.recruitment_job_id !== null && order.recruitment_job_id !== "")
                ? order.recruitment_job_id
                : order.id;
            this.$router.push({
                path: "/recruitment-cvs",
                query: {
                    job_id: String(rJobId),
                    recruitment_job_id: String(rJobId),
                    order_id: String(order.id),
                },
            }).catch(() => {});
        },
        handleDelete(order) {
            const title = order.title || order.position_title || `#${order.id}`;
            this.$confirm(`Bạn có chắc chắn muốn xoá yêu cầu tuyển dụng "${title}"?`, "Xác nhận xoá", {
                confirmButtonText: "Xoá",
                cancelButtonText: "Huỷ",
                type: "warning",
            })
                .then(() => {
                    this.$store
                        .dispatch(RO_DELETE_ORDER, order.id)
                        .then(() => {
                            this.$message.success("Xoá yêu cầu tuyển dụng thành công");
                            this.loadOrders();
                        })
                        .catch((err) => {
                            const msg = this.extractApiErrorMessage(err, "Xoá order thất bại");
                            this.$message.error(msg);
                        });
                })
                .catch(() => {});
        },
        handleTeamleadApprove(payload) {
            this.handleApproveOrder(payload);
        },
        handleApproveWithCoordinator({ order, coordinator_id }) {
            this.submitting = true;
            const updatePayload = {
                id: order.id,
                hr_approve: 1,
                coordinator_id: coordinator_id,
            };
            this.$store
                .dispatch(RO_UPDATE_ORDER, updatePayload)
                .then(() => {
                    this.$message.success("HR duyệt và gán Người điều phối thành công");
                    this.approveCoordinatorDialogVisible = false;
                    this.selectedApproveCoordinatorOrder = null;
                    if (this.selectedOrder && String(this.selectedOrder.id) === String(order.id)) {
                        this.selectedOrder = {
                            ...this.selectedOrder,
                            ...updatePayload,
                        };
                    }
                    if (this.selectedEditOrder && String(this.selectedEditOrder.id) === String(order.id)) {
                        this.selectedEditOrder = {
                            ...this.selectedEditOrder,
                            ...updatePayload,
                        };
                        this.formDialogVisible = false;
                    }
                    this.loadOrders();
                })
                .catch((err) => {
                    const msg = this.extractApiErrorMessage(err, "HR duyệt và gán người điều phối thất bại");
                    this.$message.error(msg);
                })
                .finally(() => {
                    this.submitting = false;
                });
        },
        handleApproveOrder({ order, role, status, reason }) {
            const numStatus = Number(status);
            // Xác định vai trò duyệt: "hr" hoặc "teamlead"
            let targetRole = role;
            if (!targetRole) {
                if (this.canApproveHr && !this.canApproveTeamlead) targetRole = "hr";
                else targetRole = "teamlead";
            }

            const isHrRole = targetRole === "hr";
            const roleName = isHrRole ? "HR" : "Teamlead";
            const title = (order && (order.title || order.position_title)) || `#${(order && order.id) || ""}`;

            // 1. Trường hợp Từ chối (status === 2): Bắt buộc nhập lý do
            if (numStatus === 2) {
                const promptMsg = isHrRole
                    ? "Nhập lý do HR từ chối yêu cầu tuyển dụng (bắt buộc):"
                    : "Nhập lý do Teamlead từ chối yêu cầu tuyển dụng (bắt buộc):";
                const promptTitle = `Xác nhận ${roleName} từ chối`;

                const doReject = (rejectReason) => {
                    const updatePayload = {
                        id: order.id,
                    };
                    if (isHrRole) {
                        updatePayload.hr_approve = 2;
                        updatePayload.hr_reason_reject = rejectReason;
                    } else {
                        updatePayload.teamlead_approve = 2;
                        updatePayload.team_lead_reason_reject = rejectReason;
                    }

                    this.submitting = true;
                    this.$store
                        .dispatch(RO_UPDATE_ORDER, updatePayload)
                        .then(() => {
                            this.$message.success(`${roleName} từ chối yêu cầu tuyển dụng thành công`);
                            if (this.selectedOrder && String(this.selectedOrder.id) === String(order.id)) {
                                this.selectedOrder = {
                                    ...this.selectedOrder,
                                    ...updatePayload,
                                };
                            }
                            if (this.selectedEditOrder && String(this.selectedEditOrder.id) === String(order.id)) {
                                this.selectedEditOrder = {
                                    ...this.selectedEditOrder,
                                    ...updatePayload,
                                };
                                this.formDialogVisible = false;
                            }
                            this.loadOrders();
                        })
                        .catch((err) => {
                            const msg = this.extractApiErrorMessage(err, `${roleName} từ chối order thất bại`);
                            this.$message.error(msg);
                        })
                        .finally(() => {
                            this.submitting = false;
                        });
                };

                if (reason && String(reason).trim()) {
                    doReject(String(reason).trim());
                } else {
                    this.$prompt(promptMsg, promptTitle, {
                        confirmButtonText: "Xác nhận từ chối",
                        cancelButtonText: "Huỷ",
                        inputType: "textarea",
                        inputPlaceholder: "Nhập chi tiết lý do từ chối...",
                        inputPattern: /\S+/,
                        inputErrorMessage: "Vui lòng nhập lý do từ chối",
                    })
                        .then(({ value }) => {
                            doReject(value ? value.trim() : "");
                        })
                        .catch(() => {});
                }
                return;
            }

            // 2. Trường hợp Duyệt (status === 1)
            // Nếu là HR duyệt (Chị Ngà / HR Lead) và là job Tuyển hộ (KHSX):
            // Nếu KHSX chưa chọn trưởng nhóm phụ trách -> bắt buộc chọn "Người điều phối"
            const isTeacherOrder = Number(order.type) === TYPE_TUYEN_HO || orderTypeOf(order) === TYPE_TUYEN_HO;
            const hasPic = !!(order.person_in_charge_id || (order.person_in_charge && order.person_in_charge.id));
            if (numStatus === 1 && isHrRole && isTeacherOrder && !hasPic) {
                this.selectedApproveCoordinatorOrder = { ...order };
                this.approveCoordinatorDialogVisible = true;
                return;
            }

            let actionText = numStatus === 1 ? "Duyệt" : "Chuyển về Chờ duyệt";
            let confirmType = numStatus === 1 ? "success" : "info";
            const confirmMsg = `Bạn có chắc chắn muốn thực hiện "${roleName} ${actionText}" cho yêu cầu tuyển dụng "${title}"?`;

            this.$confirm(confirmMsg, `Xác nhận ${roleName} ${actionText}`, {
                confirmButtonText: "Đồng ý",
                cancelButtonText: "Huỷ",
                type: confirmType,
            })
                .then(() => {
                    const updatePayload = {
                        id: order.id,
                    };
                    if (isHrRole) {
                        updatePayload.hr_approve = numStatus;
                    } else {
                        updatePayload.teamlead_approve = numStatus;
                    }

                    this.submitting = true;
                    this.$store
                        .dispatch(RO_UPDATE_ORDER, updatePayload)
                        .then(() => {
                            this.$message.success(`${roleName} ${actionText} yêu cầu tuyển dụng thành công`);
                            if (this.selectedOrder && String(this.selectedOrder.id) === String(order.id)) {
                                this.selectedOrder = {
                                    ...this.selectedOrder,
                                    ...updatePayload,
                                };
                            }
                            if (this.selectedEditOrder && String(this.selectedEditOrder.id) === String(order.id)) {
                                this.selectedEditOrder = {
                                    ...this.selectedEditOrder,
                                    ...updatePayload,
                                };
                                this.formDialogVisible = false;
                            }
                            this.loadOrders();
                        })
                        .catch((err) => {
                            const msg = this.extractApiErrorMessage(err, `${roleName} ${actionText} order thất bại`);
                            this.$message.error(msg);
                        })
                        .finally(() => {
                            this.submitting = false;
                        });
                })
                .catch(() => {});
        },
    },
};
</script>

<style scoped>
.ro-page {
    padding: 6px 2px 28px;
}
.ro-toolbar {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    align-items: center;
    justify-content: space-between;
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 16px 20px;
    margin-bottom: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}
.ro-toolbar__left {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
}
.ro-toolbar__brand {
    display: flex;
    align-items: center;
    gap: 12px;
}
.ro-toolbar__icon-box {
    width: 42px;
    height: 42px;
    border-radius: 10px;
    background: linear-gradient(135deg, #4f46e5 0%, #6366f1 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-size: 20px;
    box-shadow: 0 4px 10px rgba(79, 70, 229, 0.25);
}
.ro-toolbar__title {
    margin: 0;
    font-size: 18px;
    font-weight: 700;
    color: #0f172a;
    line-height: 1.25;
}
.ro-toolbar__subtitle {
    font-size: 12.5px;
    color: #64748b;
    margin-top: 2px;
}
.ro-toolbar__right {
    display: flex;
    align-items: center;
    gap: 10px;
}
.ro-btn-refresh {
    border-radius: 8px !important;
    font-weight: 500;
}
.ro-btn-create {
    border-radius: 8px !important;
    font-weight: 600;
    background: #4f46e5 !important;
    border-color: #4f46e5 !important;
    box-shadow: 0 2px 6px rgba(79, 70, 229, 0.3);
}
.ro-btn-create:hover {
    background: #4338ca !important;
    border-color: #4338ca !important;
}
.ro-role {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    font-weight: 600;
    padding: 5px 12px;
    border-radius: 999px;
    background: #f1f5f9;
    color: #475569;
    border: 1px solid #e2e8f0;
}
.ro-role--hr_lead {
    background: #ecfdf5;
    color: #047857;
    border-color: #a7f3d0;
}
.ro-role--teacher_approver {
    background: #fef3c7;
    color: #b45309;
    border-color: #fde68a;
}
.ro-role--coordinator {
    background: #eef2ff;
    color: #4338ca;
    border-color: #c7d2fe;
}
.ro-role--hr_teamlead {
    background: #e0f2fe;
    color: #0369a1;
    border-color: #bae6fd;
}
.ro-role--bod {
    background: #fae8ff;
    color: #86198f;
    border-color: #f5d0fe;
}
.ro-role--truong_phong {
    background: #ede9fe;
    color: #6d28d9;
    border-color: #ddd6fe;
}
.ro-role--truong_bo_phan {
    background: #e0e7ff;
    color: #3730a3;
    border-color: #c7d2fe;
}
.ro-role--truong_nhom,
.ro-role--team_lead {
    background: #fdf4ff;
    color: #a21caf;
    border-color: #fbcfe8;
}

/* KPI Stat Cards */
.ro-stats-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 14px;
    margin-bottom: 16px;
}
@media (max-width: 992px) {
    .ro-stats-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}
@media (max-width: 576px) {
    .ro-stats-grid {
        grid-template-columns: 1fr;
    }
}
.ro-stat-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 14px 18px;
    display: flex;
    align-items: center;
    gap: 14px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.ro-stat-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.06);
}
.ro-stat-card__icon {
    width: 44px;
    height: 44px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    flex-shrink: 0;
}
.ro-stat-card__content {
    flex: 1;
    min-width: 0;
}
.ro-stat-card__label {
    font-size: 12px;
    font-weight: 500;
    color: #64748b;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.ro-stat-card__value {
    font-size: 20px;
    font-weight: 700;
    color: #0f172a;
    line-height: 1.2;
    margin-top: 2px;
}
.ro-stat-card--indigo .ro-stat-card__icon {
    background: #eef2ff;
    color: #4f46e5;
}
.ro-stat-card--amber .ro-stat-card__icon {
    background: #fffbeb;
    color: #d97706;
}
.ro-stat-card--emerald .ro-stat-card__icon {
    background: #ecfdf5;
    color: #059669;
}
.ro-stat-card--blue .ro-stat-card__icon {
    background: #f0f9ff;
    color: #0284c7;
}

.ro-tabs {
    margin-bottom: 12px;
}
.ro-tabs /deep/ .el-tabs__header {
    margin: 0;
}
.ro-tabs /deep/ .el-tabs__nav-wrap::after {
    height: 1px;
    background-color: #e2e8f0;
}
.ro-tabs /deep/ .el-tabs__item {
    font-size: 13.5px;
    font-weight: 500;
    color: #64748b;
    padding: 0 16px;
    height: 42px;
    line-height: 42px;
}
.ro-tabs /deep/ .el-tabs__item.is-active {
    font-weight: 700;
    color: #4f46e5;
}
.ro-tab-count {
    display: inline-block;
    padding: 0 7px;
    height: 18px;
    line-height: 18px;
    border-radius: 9px;
    font-size: 11px;
    font-weight: 700;
    background: #f1f5f9;
    color: #475569;
    margin-left: 6px;
}
.ro-tab-count--info {
    background: #e0e7ff;
    color: #4338ca;
}
.ro-tab-count--warn {
    background: #fef3c7;
    color: #b45309;
}
.ro-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 16px;
    margin-bottom: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}
.ro-filter-card {
    padding: 12px 16px;
}
.ro-pagination {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
    padding-top: 14px;
    border-top: 1px solid #f1f5f9;
}
.ro-pagination /deep/ .el-pagination,
.ro-pagination ::v-deep .el-pagination {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-weight: normal;
    color: #64748b;
}
.ro-pagination /deep/ .el-pagination > span,
.ro-pagination /deep/ .el-pagination > button,
.ro-pagination /deep/ .el-pagination > ul,
.ro-pagination ::v-deep .el-pagination > span,
.ro-pagination ::v-deep .el-pagination > button,
.ro-pagination ::v-deep .el-pagination > ul {
    display: inline-flex;
    align-items: center;
    height: 28px;
    line-height: 28px;
    vertical-align: middle;
}
.ro-pagination /deep/ .el-pagination .el-pagination__total,
.ro-pagination ::v-deep .el-pagination .el-pagination__total {
    margin-right: 8px;
    height: 28px;
    line-height: 28px;
    display: inline-flex;
    align-items: center;
}
.ro-pagination /deep/ .el-pagination .el-pagination__sizes,
.ro-pagination ::v-deep .el-pagination .el-pagination__sizes {
    margin-right: 8px;
    height: 28px;
    display: inline-flex;
    align-items: center;
}
.ro-pagination /deep/ .el-pagination .el-pagination__sizes .el-input,
.ro-pagination ::v-deep .el-pagination .el-pagination__sizes .el-input {
    margin: 0;
    vertical-align: middle;
}
.ro-pagination /deep/ .el-pagination .el-pagination__sizes .el-input .el-input__inner,
.ro-pagination ::v-deep .el-pagination .el-pagination__sizes .el-input .el-input__inner {
    height: 28px;
    line-height: 28px;
}
.ro-pagination /deep/ .el-pagination .btn-prev,
.ro-pagination /deep/ .el-pagination .btn-next,
.ro-pagination ::v-deep .el-pagination .btn-prev,
.ro-pagination ::v-deep .el-pagination .btn-next {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 28px;
    line-height: 28px;
    padding: 0 4px;
    margin: 0 2px;
}
.ro-pagination /deep/ .el-pagination .el-pager,
.ro-pagination ::v-deep .el-pagination .el-pager {
    display: inline-flex;
    align-items: center;
    height: 28px;
    line-height: 28px;
    padding: 0;
    margin: 0;
}
.ro-pagination /deep/ .el-pagination .el-pager li,
.ro-pagination ::v-deep .el-pagination .el-pager li {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 28px;
    line-height: 28px;
    min-width: 28px;
    margin: 0 2px;
    font-size: 13px;
    border-radius: 4px;
}
.ro-pagination /deep/ .el-pagination .el-pagination__jump,
.ro-pagination ::v-deep .el-pagination .el-pagination__jump {
    display: inline-flex;
    align-items: center;
    height: 28px;
    line-height: 28px;
    margin-left: 10px;
    color: #64748b;
}
.ro-pagination /deep/ .el-pagination .el-pagination__jump .el-pagination__editor.el-input,
.ro-pagination ::v-deep .el-pagination .el-pagination__jump .el-pagination__editor.el-input {
    margin: 0 4px;
    vertical-align: middle;
}
.ro-pagination /deep/ .el-pagination .el-pagination__jump .el-input__inner,
.ro-pagination ::v-deep .el-pagination .el-pagination__jump .el-input__inner {
    height: 28px;
    line-height: 28px;
}
.ro-coordinate-banner {
    display: flex;
    align-items: center;
    gap: 16px;
    background: linear-gradient(135deg, #eef2ff 0%, #f5f3ff 100%);
    border: 1px solid #c7d2fe;
    border-radius: 12px;
    padding: 14px 18px;
    margin-bottom: 16px;
    box-shadow: 0 1px 3px rgba(79, 70, 229, 0.06);
}
.ro-coordinate-banner__icon {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: #4f46e5;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    flex-shrink: 0;
    box-shadow: 0 2px 6px rgba(79, 70, 229, 0.3);
}
.ro-coordinate-banner__body {
    flex: 1;
    min-width: 0;
}
.ro-coordinate-banner__title {
    font-size: 14px;
    font-weight: 700;
    color: #312e81;
    margin-bottom: 3px;
}
.ro-coordinate-banner__desc {
    font-size: 12.5px;
    color: #4338ca;
    line-height: 1.45;
}
.ro-coordinate-banner__action {
    flex-shrink: 0;
}
.ro-coordinate-banner__pill {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 14px;
    border-radius: 999px;
    background: #ffffff;
    border: 1px solid #c7d2fe;
    font-size: 12px;
    font-weight: 600;
    color: #4338ca;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

</style>
